import React from 'react';
import { PedagogicalChallengesView } from './PedagogicalChallenges.view';
import goToPage from 'helpers/page/goToPage';
import pages from 'routes/pages';
import { useQuery } from '@apollo/client';
import { HomeDefisQuery } from 'graphql/generated/graphql';
import QUERY_ALL_PEDAGOGICAL_CHALLENGES from 'graphql/query/defi/homeDefis';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { GraphQLError } from 'graphql';

const PedagogicalChallenges = () => {
  const { data, loading, error } = useQuery<HomeDefisQuery>(
    QUERY_ALL_PEDAGOGICAL_CHALLENGES
  );

  const goToSinglePedagogicalChallenge = (id: number) =>
    goToPage(pages.PEDAGOGICAL_CHALLENGE_SINGLE.path, { id: id });

  if (loading) return <LoadingLayout />;
  if (error)
    return (
      <ErrorContainer
        detailErr={new GraphQLError('Erreur dans la récupération des défis')}
      />
    );

  return (
    <PedagogicalChallengesView
      goToSinglePedagogicalChallenge={goToSinglePedagogicalChallenge}
      defis={data.getHomeDefis}
    />
  );
};

export default PedagogicalChallenges;
